'use strict';

var $ = window.jQuery;
var universalGA = require('./analytics/googleAnalyticsEvents');
var analytics = require('./analytics');
var raven = require('./analytics/raven');
var genbar = require('./genbar/generationBar');
var exitPages = require('./exit-pages/exitPages');
var simpleTooltip = require('./helpers/simpleTooltip');
// Analytics
raven.init();
universalGA.init();
analytics.init();

// Define placeholder for the mustache templates
window.mustacheTemplates = {};

// Exit page strategy
exitPages();

// Boostrap JS extended
require('./bootstrap-extended/animations');
require('./bootstrap-extended/tooltip-closer');

// Seasonal Event
require('./seasonal-events/halloween-2015/halloween')();
require('./seasonal-events/new-year-2015/new-year')();

genbar.init();

window.isMobile = window.isMobile || false;

// fix cors for ie ?
$.support.cors = true;

if (typeof window.moment !== 'undefined') {
  window.moment.locale(window.wooGlobal.language);
}

// Jquery Plugins
require('./jquery-plugins/externalLinks');
require('./jquery-plugins/truncate');
require('./jquery-plugins/formatTime');
require('./jquery-plugins/prettyTextOverflow');

// Helpers
require('./helpers/topNavigationBar');
require('./helpers/leftMenu');
require('./helpers/validateForm');
require('./helpers/toggleAccordion');
require('./helpers/wooPopover');
require('./helpers/contactSupport');

if ($('body').hasClass('home')) {
  require('./helpers/homepageScroll');
}

if ($('body').hasClass('gaprofiles') || $('body').hasClass('settings')) {
  require('./settings/settings');
}

if ($('body').hasClass('overview')) {
  require('./overview/overview');
  require('./bootstrap-extended/popover-closer');
}

if ($('body').hasClass('user')) {
  require('./user/cancelSubscription');
  require('./user/toggleInvoices');
  require('./login/login');
}

if ($('body').hasClass('subusers')) {
  require('./subusers/subusers');
}

if ($('body').hasClass('review')) {
  require('./review/review');
  require('./modals/deleteReview');
  require('./bootstrap-extended/popover-closer');
}

if ($('body').hasClass('generating')) {
  require('./generate-socket/generateSocket');
}

if ($('body').hasClass('pdf')) {
  require('./pdf/pdf');
}

if ($('body').hasClass('shared')) {
  require('./shared/shared');
}

if ($('body').hasClass('pricing')) {
  require('./pricing/pricing');
  require('./g-recaptcha/recaptchaOnload');
}

if ($('body').hasClass('login')) {
  require('./login/login');
  require('./login/loginWithQuestions');
  require('./g-recaptcha/recaptchaOnload');
}

if ($('body').hasClass('forgot-password')) {
  require('./login/login');
}

if ($('body').hasClass('register')) {
  require('./register/register');
}

if ($('body').hasClass('update-billing-details')) {
  require('./register/updateBillingDetails');
}

if ($('body').hasClass('plans')) {
  require('./plans/plans');
}

if ($('body').hasClass('js-sync-popup')) {
  require('./components/form-list');
}

if ($('body').hasClass('pdf-editor')) {
  require('./pdf-editor/pdf-editor');
}

if ($('body').hasClass('error')) {
  require('./review/error');
}

if ($('body').hasClass('first-generation-review-confirmation')) {
  require('./review/firstGenerationReview');
}

universalGA.bind();

simpleTooltip();

require('./helpers/jsLoadEnd');
